import { render } from "./ResetPassword.vue?vue&type=template&id=07d89e88&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=07d89e88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07d89e88"

export default script